<div class="headline-container">
  <span class="headline">
    {{ 'home.preorders.overview.title' | translate }}
    <span *ngIf="(preorders$ | async) as p">
      ({{ p.totalElements }})
    </span>
  </span>
  <div class="controls">
    <select class="select" (change)="onPreorderStatusChange($event.target.value)">
      <option [value]="''" [selected]="preorderStatus === null">{{ 'home.preorders.overview.status' | translate }}</option>
      <option *ngFor="let e of preorderStatusEnum" [value]="e" [selected]="preorderStatus === e">{{ 'home.preorders.overview.table.status.' + e | translate }}</option>
    </select>
    <input type="text" class="input small-input"
           [placeholder]="'home.preorders.overview.search-reference' | translate"
           (input)="onReferenceFilterChange($event.target.value)"
    >
  </div>
</div>
<ng-container *ngIf="(preorders$ | async) as preorders">
  <app-preorder-overview-table
    class="overview-table"
    [preorders]="preorders.content"
    (openDetails)="onOpenDetails($event)"
  ></app-preorder-overview-table>
  <app-pagination
    [page]="preorders.number + 1"
    [size]="preorders.size"
    [totalElements]="preorders.totalElements"
    (pageSelected)="onPageSelected($event - 1)"
    (sizeSelected)="onSizeSelected($event)"
  ></app-pagination>
</ng-container>

